// import {
//   addExpenseAccount,
//   getAllDriver,
//   getChartExpense,
//   getUserAccountList,
//   handleKeyDown,
//   transferFundApi,
//   uploadFiles,
//   venderDropdownApi,
// } from "_services";
// import {
//   CommonCanvas,
//   CommonDatePicker,
//   CommonInput,
//   CommonModal,
//   CommonSwitch,
//   CustomSelect,
// } from "components";
// import { Images } from "constants";
// import { UserContext } from "context";
// import { errorSchema, utils } from "helper";
// import React, { useContext, useEffect, useState } from "react";
// import toast from "react-hot-toast";
// import { IoCloseCircle } from "react-icons/io5";
// import StorageService from "utils/StorageServices";

// const TransferModal = (props) => {
//   const arryOptions = [
//     { label: "Goods", value: "Goods" },
//     { label: "Service", value: "Service" },
//   ];

//   const initial = {
//     company_id: StorageService.getCompanyId(),
//     date: new Date(),
//     from_account_category: "",
//     from_account_sub_category: "",
//     from_account_id: "",
//     // from_driver_id: "",

//     to_account_category: "",
//     to_account_sub_category: "",
//     to_account_id: "",
//     // to_driver_id: "",
//     transaction_no: "",
//     description: "",
//     amount: "",
//   };

//   const { masterData, states } = useContext(UserContext);
//   const [form, setForm] = useState(initial);
//   const [expenseTypeList, setExpenseTypeList] = useState([]);
//   const [formError, setFormError] = useState("");
//   const [accountLoading, setAccountLoading] = useState(false);
//   const [fromaccountList, setFromAccountList] = useState([]);
//   const [toaccountList, setToAccountList] = useState([]);
//   const [driverList, setDriverList] = useState([]);
//   const [showAddMore, setAddMore] = useState(false);
//   const [accountType, setAccountType] = useState();
//   const [accountTypeto, setAccountTypeto] = useState();
//   const [isLoadding, setIsLoadding] = useState(false);
//   const [accountArray, setAccountArray] = useState([])


//   useEffect(() => {
//     if (masterData) {
//       getDriverList();
//       initializeForm();
//     }
//   }, [masterData]);

//   useEffect(() => {
//     setAccountArray((prevArray) => {
//       // Get current selected accounts
//       const selectedAccounts = [form?.to_account_id, form?.from_account_id]

//       // Remove accounts that are no longer selected
//       let updatedArray = prevArray.filter((account) =>
//         selectedAccounts.includes(account)
//       );

//       // Add new accounts if not already in the array
//       selectedAccounts.forEach((id) => {
//         if (!updatedArray.some((account) => account === id)) {
//           updatedArray.push(id); // Modify this to match your account object structure
//         }
//       });

//       return updatedArray;
//     });
//   }, [form?.to_account_id, form?.from_account_id]);

//   useEffect(() => {
//     if (
//       form?.from_account_sub_category != "15" &&
//       form?.from_account_category &&
//       expenseTypeList.length
//     ) {
//       if (form?.from_account_id == "") {
//         fetchAccountList("from");
//       }
//     }
//   }, [
//     form?.from_account_sub_category,
//     form?.from_account_category,
//     expenseTypeList,
//     form?.from_account_id,
//   ]);

//   useEffect(() => {
//     if (
//       form?.to_account_sub_category != "15" &&
//       form?.to_account_category &&
//       expenseTypeList.length
//     ) {
//       if (form?.to_account_id == "" || accountArray.length) {
//         fetchAccountList("to");
//       }
//     }
//   }, [
//     form?.to_account_sub_category,
//     form?.to_account_category,
//     expenseTypeList,
//     form?.to_account_id,
//     accountArray,
//   ]);

//   useEffect(() => {
//     if (accountType) {
//       setForm({ ...form, from_account_id: "" });
//     }
//   }, [accountType]);

//   useEffect(() => {
//     if (accountTypeto) {
//       setForm({ ...form, to_account_id: "" });
//     }
//   }, [accountTypeto]);

//   const handleOnChange = async (name, value) => {
//     const stateObj = {
//       ...form,
//       [name]: value,
//     };
//     setForm(stateObj);

//     if (!!formError) {
//       const validationResult = await utils.checkFormError(
//         { ...stateObj },
//         errorSchema.addExpenseAccountSchema
//       );
//       if (validationResult === true) {
//         setFormError("");
//       } else {
//         setFormError(validationResult);
//       }
//     }
//   };

//   const initializeForm = () => {
//     const detailsAccount = masterData?.own_account_category?.sub_category
//       ?.filter((item) => item.id !== 10)
//       ?.map((item) => ({
//         label: item.name,
//         value: item.id,
//         category_id: masterData?.own_account_category?.id,
//       }));

//     if (detailsAccount?.length) {
//       setForm((prevState) => ({
//         ...prevState,
//         from_account_category: detailsAccount[0]?.category_id,
//         from_account_sub_category: detailsAccount[0]?.value,
//         to_account_category: detailsAccount[0]?.category_id,
//         to_account_sub_category: detailsAccount[0]?.value,
//       }));
//       setExpenseTypeList(detailsAccount);
//     }
//   };

//   const getDriverList = async () => {
//     const res = await getAllDriver({
//       company_id: StorageService.getCompanyId(),
//       offset: 1,
//       limit: 2000,
//     });
//     if (res?.responseCode === 200) {
//       setDriverList(
//         res?.data?.driver_list
//           ?.filter((i) => i?.driver_type != 2)
//           ?.map((i) => {
//             return {
//               ...i,
//               label: i.name,
//               value: i._id,
//             };
//           })
//       );
//     } else {
//       toast.error(res?.responseMessage);
//     }
//   };

//   const fetchAccountList = async (type) => {
//     setAccountLoading(true);
//     try {
//       const payload = {
//         company_id: StorageService.getCompanyId(),
//         category_id: parseInt(form[`${type}_account_category`]),
//         sub_category_id: parseInt(form[`${type}_account_sub_category`]),
//         offset: 1,
//         limit: 2000,
//       };
//       const res = await getUserAccountList(payload);

//       if (res?.responseCode === 200) {
//         const accounts = res.data.account_list.map((item) => {

//           return ({
//             label: item.name,
//             value: item._id,
//           })
//         });

//         if (type == "from") {
//           setFromAccountList(accounts?.filter(
//             (item) => !accountArray.some((acc) => acc === item.value)
//           ));
//           setForm((prevState) => ({
//           ...prevState,
//           [`${type}_account_id`]: accounts[0]?.value || "",
//         }));
//         } else {
//           setToAccountList(accounts?.filter(
//             (item) => !accountArray.some((acc) => acc === item.value)
//           ));
//           setForm((prevState) => ({
//           ...prevState,
//           [`${type}_account_id`]: accounts[0]?.value || "",
//         }));
//         }

        

        
//       } else {
//         toast.error(res.responseMessage);
//       }
//     } catch (error) {
//       toast.error("Failed to fetch accounts.");
//     } finally {
//       setAccountLoading(false);
//     }
//   };

//   const onHandleSubmit = async () => {
//     const validationResult = await utils.checkFormError(
//       { ...form },
//       errorSchema.fundTransferSchema
//     );

//     let updatedFormError = { ...validationResult };

//     if (form.from_account_id && form.to_account_id) {
//       if (
//         form.from_account_sub_category == form.to_account_sub_category &&
//         form.from_account_id == form.to_account_id
//       ) {
//         updatedFormError = {
//           ...updatedFormError,
//           from_account_id: "From Account and To Account cannot be the same.",
//           to_account_id: "From Account and To Account cannot be the same.",
//         };
//       }
//     }

//     setFormError(updatedFormError);

//     if (Object.keys(updatedFormError).length > 0) {
//       return;
//     }

//     const payload = {
//       ...form,
//       amount: form.amount || 0,
//     };



//     setIsLoadding(true);
//     try {
//       const res = await transferFundApi(payload);
//       if (res?.responseCode === 200) {
//         setIsLoadding(false);
//         props?.callBackFreight();
//         props?.closeModal();
//         toast.success(res?.responseMessage);
//       } else {
//         setIsLoadding(false);
//       }
//     } catch (error) {
//       setIsLoadding(false);
//       toast.error(error?.message);
//     }
//   };

//   const propsExpenses = {
//     ...props,
//     isLoadding: isLoadding,
//     disabled: isLoadding,

//     onSubmit: onHandleSubmit,
//   };

//   return (
//     <>
//       <CommonCanvas {...propsExpenses}>
//         <div className="offcanvas-body">
//           <div className="_lrCl_offCavBody">
//             <div className="_othrExp_recBx">
//               <div className="_clPay_flex">
//                 <div className="singleDiv">
//                   <CommonDatePicker
//                     name="date"
//                     label="As of Date"
//                     placeholderText="Expense Date"
//                     startDate={form?.date}
//                     setStartDate={(data) => {
//                       handleOnChange("date", data);
//                     }}
//                     error={formError?.date}
//                     focus={!!formError?.date}
//                     errorShow={false}
//                   />
//                 </div>

//                 <div className="px-1 w-100">
//                   <div className="_pMode_exbx">
//                     <p>From Account</p>
//                     <div className="tFlex_bd">
//                       {expenseTypeList.map((i, index) => {
//                         return (
//                           <button
//                             key={i.value}
//                             className={`_baseSpan ${i?.value == form?.from_account_sub_category
//                                 ? "active"
//                                 : "_bspDisable"
//                               }`}
//                             name="from_account_sub_category"
//                             disabled={accountLoading}
//                             value={i.value}
//                             onClick={({ target: { name, value } }) => {
//                               setAccountType(value);
//                               handleOnChange(name, Number(value));
//                             }}
//                           >
//                             {i.label}
//                           </button>
//                         );
//                       })}
//                     </div>
//                     {form?.from_account_sub_category != 11 ? (
//                       <div className="mt-4">
//                         <CustomSelect
//                           label="Select Account"
//                           options={fromaccountList?.filter(
//                             (item) => !accountArray.some((acc) => acc === item.value)
//                           )}
//                           placeholder="Select Account"
//                           name="from_account_id"
//                           onSelect={(data) => {
//                             handleOnChange("from_account_id", data?.value);
//                           }}
//                           error={formError?.from_account_id}
//                           value={
//                             form?.from_account_id
//                               ? fromaccountList?.find(
//                                 (i) => i.value == form?.from_account_id
//                               )
//                               : { label: "", value: "" }
//                           }
//                         // errorShow={false}
//                         />
//                       </div>
//                     ) : (
//                       <div className="mt-4">
//                         <CustomSelect
//                           label="Select Driver"
//                           options={driverList}
//                           placeholder="Select Driver"
//                           name="from_account_id"
//                           onSelect={(data) => {
//                             handleOnChange("from_account_id", data?.value);
//                           }}
//                           error={formError?.from_account_id}
//                           value={
//                             form?.from_account_id
//                               ? driverList?.find(
//                                 (i) => i.value == form?.from_account_id
//                               )
//                               : { label: "", value: "" }
//                           }
//                         // errorShow={false}
//                         />
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <div className="px-1 w-100">
//                   <div className="_pMode_exbx">
//                     <p> To Account</p>
//                     <div className="tFlex_bd">
//                       {expenseTypeList.map((i) => {
//                         return (
//                           <button
//                             className={`_baseSpan ${i?.value == form?.to_account_sub_category
//                                 ? "active"
//                                 : "_bspDisable"
//                               }`}
//                             name="to_account_sub_category"
//                             disabled={accountLoading}
//                             value={i.value}
//                             onClick={({ target: { name, value } }) => {
//                               setAccountTypeto(value);
//                               handleOnChange(name, Number(value));
//                             }}
//                           >
//                             {i.label}
//                           </button>
//                         );
//                       })}
//                     </div>
//                     {form?.to_account_sub_category != 11 ? (
//                       <div className="mt-4">
//                         <CustomSelect
//                           label="Select Account"
//                           // options={toaccountList}
//                           options={toaccountList?.filter(
//                             (item) => !accountArray.some((acc) => acc === item.value)
//                           )}
//                           placeholder="Select Account"
//                           name="to_account_id"
//                           onSelect={(data) => {
//                             handleOnChange("to_account_id", data?.value);
//                           }}
//                           error={formError["to_account_id"]}
//                           value={
//                             form?.to_account_id
//                               ? toaccountList?.find(
//                                 (i) => i.value == form?.to_account_id
//                               )
//                               : { label: "", value: "" }
//                           }
//                         // errorShow={false}
//                         />
//                       </div>
//                     ) : (
//                       <div className="mt-4">
//                         <CustomSelect
//                           label="Select Driver"
//                           options={driverList}
//                           placeholder="Select Driver"
//                           name="to_account_id"
//                           onSelect={(data) => {
//                             handleOnChange("to_account_id", data?.value);
//                           }}
//                           error={formError?.to_account_id}
//                           value={
//                             form?.to_account_id
//                               ? driverList?.find(
//                                 (i) => i.value == form?.to_account_id
//                               )
//                               : { label: "", value: "" }
//                           }
//                         // errorShow={false}
//                         />
//                       </div>
//                     )}
//                   </div>
//                   <div className="_clPay_flex">
//                     <div className="singleDiv">
//                       <CommonInput
//                         type="text"
//                         label="Amount (₹)"
//                         placeholder="Enter Amount"
//                         name="amount"
//                         className="__rupeeSymbol"
//                         rupeeSymbol={true}
//                         errorShow={true}
//                         error={formError?.amount}
//                         focus={!!formError?.amount}
//                         maxLength={10}
//                         // onKeyDown={handleKeyDown}
//                         onChange={({ target: { name, value } }) => {
//                           if (/^\d*$/.test(value)) {
//                             handleOnChange(name, value);
//                             // setPhoneError("");
//                           }
//                         }}
//                         value={form?.amount}
//                       />
//                     </div>
//                   </div>
//                   <div className="_clPay_flex fn_add_more">
//                     <span onClick={() => setAddMore(!showAddMore)}>{showAddMore ? "Less More Details" : "Add More Details"}</span>

//                   </div>
//                   {showAddMore && <>
//                     <div className="_clPay_flex">
//                       <div className="singleDiv">
//                         <CommonInput
//                           type="text"
//                           label="Description"
//                           placeholder="Enter Description"
//                           name="description"
//                           errorShow={false}
//                           error={formError?.description}
//                           focus={!!formError?.description}
//                           onChange={({ target: { name, value } }) => {
//                             handleOnChange(name, value);
//                           }}
//                         />
//                       </div>
//                     </div>
//                     <div className="_clPay_flex">
//                       <div className="singleDiv">
//                         <CommonInput
//                           type="text"
//                           label="Transaction Number"
//                           placeholder="Enter Transaction Number"
//                           name="transaction_no"
//                           errorShow={false}
//                           error={formError?.transaction_no}
//                           focus={!!formError?.transaction_no}
//                           // onKeyDown={handleKeyDown}
//                           onChange={({ target: { name, value } }) => {
//                             handleOnChange(name, value);
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </>}

//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </CommonCanvas>
//     </>
//   );
// };

// export default TransferModal;


import {
  getAllDriver,
  getUserAccountList,
  transferFundApi,
} from "_services";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CustomSelect,
} from "components";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import React, { useContext, useEffect, useState, useMemo, useCallback } from "react";
import toast from "react-hot-toast";
import StorageService from "utils/StorageServices";

const TransferModal = (props) => {
  const initial = {
    company_id: StorageService.getCompanyId(),
    date: new Date(),
    from_account_category: "",
    from_account_sub_category: "",
    from_account_id: "",
    to_account_category: "",
    to_account_sub_category: "",
    to_account_id: "",
    transaction_no: "",
    description: "",
    amount: "",
  };

  const { masterData } = useContext(UserContext);
  const [form, setForm] = useState(initial);
  const [expenseTypeList, setExpenseTypeList] = useState([]);
  const [formError, setFormError] = useState({});
  const [fromAccountLoading, setFromAccountLoading] = useState(false);
  const [toAccountLoading, setToAccountLoading] = useState(false);
  const [fromAccountLoaded, setFromAccountLoaded] = useState(false); // Track when FROM is loaded
  const [fromaccountList, setFromAccountList] = useState([]);
  const [toaccountList, setToAccountList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [showAddMore, setAddMore] = useState(false);
  const [isLoadding, setIsLoadding] = useState(false);

  // Form reset function
  const resetForm = useCallback(() => {
    setForm(initial);
    setFormError({});
    setFromAccountList([]);
    setToAccountList([]);
    setAddMore(false);
    setFromAccountLoaded(false); // Reset loaded state
  }, []);

  // Handle form change
  const handleOnChange = useCallback(async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };
    setForm(stateObj);

    // Clear specific field error
    if (formError[name]) {
      setFormError(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  }, [form, formError]);

  // Handle amount input
  const handleAmountChange = useCallback((name, value) => {
    if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
      handleOnChange(name, value);
    }
  }, [handleOnChange]);

  // Initialize form
  useEffect(() => {
    if (masterData) {
      getDriverList();
      initializeForm();
    }
  }, [masterData]);

  const initializeForm = useCallback(() => {
    try {
      const detailsAccount = masterData?.own_account_category?.sub_category
        ?.filter((item) => item.id !== 10)
        ?.map((item) => ({
          label: item.name,
          value: item.id,
          category_id: masterData?.own_account_category?.id,
        }));

      if (detailsAccount?.length) {
        const defaultCategory = detailsAccount[0];
        setForm((prevState) => ({
          ...prevState,
          from_account_category: defaultCategory.category_id,
          from_account_sub_category: defaultCategory.value,
          to_account_category: defaultCategory.category_id,
          to_account_sub_category: defaultCategory.value,
        }));
        setExpenseTypeList(detailsAccount);
      }
    } catch (error) {
      console.error('Error initializing form:', error);
      toast.error('Failed to initialize form');
    }
  }, [masterData]);

  const getDriverList = async () => {
    try {
      const res = await getAllDriver({
        company_id: StorageService.getCompanyId(),
        offset: 1,
        limit: 2000,
        driver_type: [1, 3]
      });
      
      if (res?.responseCode === 200) {
        setDriverList(
          res?.data?.driver_list
            ?.filter((i) => i?.driver_type !== 2)
            ?.map((i) => ({
              ...i,
              label: i.name,
              value: i._id,
            })) || []
        );
      } else {
        toast.error(res?.responseMessage || "Failed to fetch drivers");
      }
    } catch (error) {
      console.error('Error fetching drivers:', error);
      toast.error("Failed to fetch drivers");
    }
  };

  // Load FROM account FIRST - only when category/subcategory changes
  useEffect(() => {
    if (form?.from_account_category && 
        form?.from_account_sub_category && 
        form?.from_account_sub_category !== "15" && 
        expenseTypeList.length > 0) {
      setFromAccountLoaded(false); // Reset before loading
      fetchAccountList("from");
    }
  }, [
    form?.from_account_category,
    form?.from_account_sub_category,
    expenseTypeList.length
  ]);

  // Load TO account SECOND - wait for FROM account to load completely
  useEffect(() => {
    if (form?.to_account_category && 
        form?.to_account_sub_category && 
        form?.to_account_sub_category !== "15" && 
        expenseTypeList.length > 0 &&
        fromAccountLoaded) { // ✅ Wait for FROM account to complete
      fetchAccountList("to");
    }
  }, [
    form?.to_account_category,
    form?.to_account_sub_category,
    expenseTypeList.length,
    fromAccountLoaded // ✅ Trigger when FROM account loads
  ]);

  const fetchAccountList = async (type) => {
    const setLoading = type === "from" ? setFromAccountLoading : setToAccountLoading;
    setLoading(true);
    
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        category_id: parseInt(form[`${type}_account_category`]),
        sub_category_id: parseInt(form[`${type}_account_sub_category`]),
        offset: 1,
        limit: 2000,
      };
      
      const res = await getUserAccountList(payload);

      if (res?.responseCode === 200) {
        const accounts = res.data.account_list.map((item) => ({
          label: item.name,
          value: item._id,
        }));

        if (type === "from") {
          setFromAccountList(accounts);
          // Set default from account only if empty
          if (!form.from_account_id && accounts.length > 0) {
            setForm(prevState => ({
              ...prevState,
              from_account_id: accounts[0].value,
            }));
          }
          // ✅ Mark FROM account as loaded
          setFromAccountLoaded(true);
        } else {
          // Just set the full list - filtering happens in useMemo
          setToAccountList(accounts);
          
          // Set default to account only if empty AND different from from_account
          if (!form.to_account_id && accounts.length > 0) {
            // Get current FROM account ID from form state
            setForm(prevState => {
              const currentFromAccountId = prevState.from_account_id;
              
              // Filter out the FROM account from available TO accounts
              const filteredAccounts = accounts.filter(item => item.value !== currentFromAccountId);
              
              // Only set TO account if there are other options available
              if (filteredAccounts.length > 0) {
                return {
                  ...prevState,
                  to_account_id: filteredAccounts[0].value,
                };
              }
              
              // If no other account available, don't set TO account
              return prevState;
            });
          }
        }
      } else {
        toast.error(res?.responseMessage || "Failed to fetch accounts");
        if (type === "from") {
          setFromAccountLoaded(true); // Still mark as complete even on error
        }
      }
    } catch (error) {
      console.error('Error fetching accounts:', error);
      toast.error("Failed to fetch accounts.");
      if (type === "from") {
        setFromAccountLoaded(true); // Still mark as complete even on error
      }
    } finally {
      setLoading(false);
    }
  };

  const onHandleSubmit = async () => {
    const validationResult = await utils.checkFormError(
      { ...form },
      errorSchema.fundTransferSchema
    );

    let updatedFormError = typeof validationResult === 'object' ? { ...validationResult } : {};

    // Same account validation
    if (form.from_account_id && form.to_account_id && form.from_account_id === form.to_account_id) {
      const errorMessage = "From Account and To Account cannot be the same.";
      updatedFormError = {
        ...updatedFormError,
        from_account_id: errorMessage,
        to_account_id: errorMessage,
      };
    }

    // Amount validation
    if (!form.amount || parseFloat(form.amount) <= 0) {
      updatedFormError = {
        ...updatedFormError,
        amount: "Amount is required and must be greater than 0.",
      };
    }

    // Account selection validation
    if (!form.from_account_id) {
      updatedFormError = {
        ...updatedFormError,
        from_account_id: "Please select a from account.",
      };
    }

    if (!form.to_account_id) {
      updatedFormError = {
        ...updatedFormError,
        to_account_id: "Please select a to account.",
      };
    }

    setFormError(updatedFormError);

    if (Object.keys(updatedFormError).length > 0) {
      return;
    }

    const payload = {
      ...form,
      amount: (form.amount ?? 0).toString(),
    };

    setIsLoadding(true);
    try {
      const res = await transferFundApi(payload);
      if (res?.responseCode === 200) {
        resetForm();
        props?.callBackFreight?.();
        props?.closeModal?.();
        toast.success(res?.responseMessage || "Transfer completed successfully");
      }
    } catch (error) {
      console.error('Transfer error:', error);
    } finally {
      setIsLoadding(false);
    }
  };

  // Account category change handler
  const handleAccountTypeChange = (type, name, value) => {
    handleOnChange(name, Number(value));
    // Clear selected account when category changes
    const accountIdField = type === 'from' ? 'from_account_id' : 'to_account_id';
    setForm(prev => ({ ...prev, [accountIdField]: "" }));
    
    // Reset loaded flag when FROM category changes
    if (type === 'from') {
      setFromAccountLoaded(false);
    }
  };

  // Filtered account lists - same account ko exclude karta hai
  const filteredFromAccountList = useMemo(() => 
    fromaccountList.filter(item => item.value !== form.to_account_id), 
    [fromaccountList, form.to_account_id]
  );

  const filteredToAccountList = useMemo(() => 
    toaccountList.filter(item => item.value !== form.from_account_id), 
    [toaccountList, form.from_account_id]
  );

  // Filtered driver lists - same driver ko exclude karta hai
  const filteredFromDriverList = useMemo(() => 
    driverList.filter(item => item.value !== form.to_account_id), 
    [driverList, form.to_account_id]
  );

  const filteredToDriverList = useMemo(() => 
    driverList.filter(item => item.value !== form.from_account_id), 
    [driverList, form.from_account_id]
  );

  const propsExpenses = {
    ...props,
    isLoadding: isLoadding,
    disabled: isLoadding,
    onSubmit: onHandleSubmit,
  };

  return (
    <CommonCanvas {...propsExpenses}>
      <div className="offcanvas-body">
        <div className="_lrCl_offCavBody">
          <div className="_othrExp_recBx tesxx">
            <div className="_clPay_flex">
              <div className="singleDiv">
                <CommonDatePicker
                  name="date"
                  label="As of Date"
                  placeholderText="Expense Date"
                  startDate={form?.date}
                  setStartDate={(data) => handleOnChange("date", data)}
                  error={formError?.date}
                  focus={!!formError?.date}
                  errorShow={false}
                />
              </div>

              <div className="px-1 w-100">
                <div className="_pMode_exbx">
                  <p>From Account</p>
                  <div className="tFlex_bd">
                    {expenseTypeList.map((i) => (
                      <button
                        key={i.value}
                        className={`_baseSpan ${
                          i?.value == form?.from_account_sub_category
                            ? "active"
                            : "_bspDisable"
                        }`}
                        disabled={fromAccountLoading || toAccountLoading || isLoadding}
                        onClick={() => handleAccountTypeChange('from', 'from_account_sub_category', i.value)}
                      >
                        {i.label}
                      </button>
                    ))}
                  </div>
                  {form?.from_account_sub_category != 11 ? (
                    <div className="mt-4">
                      <CustomSelect
                        label="Select Account"
                        options={filteredFromAccountList}
                        placeholder="Select Account"
                        name="from_account_id"
                        onSelect={(data) => handleOnChange("from_account_id", data?.value)}
                        error={formError?.from_account_id}
                        value={
                          form?.from_account_id
                            ? filteredFromAccountList?.find(
                                (i) => i.value == form?.from_account_id
                              )
                            : { label: "", value: "" }
                        }
                        isLoading={fromAccountLoading}
                      />
                    </div>
                  ) : (
                    <div className="mt-4">
                      <CustomSelect
                        label="Select Driver"
                        options={filteredFromDriverList}
                        placeholder="Select Driver"
                        name="from_account_id"
                        onSelect={(data) => handleOnChange("from_account_id", data?.value)}
                        error={formError?.from_account_id}
                        value={
                          form?.from_account_id
                            ? filteredFromDriverList?.find(
                                (i) => i.value == form?.from_account_id
                              )
                            : { label: "", value: "" }
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
              
              <div className="px-1 w-100">
                <div className="_pMode_exbx">
                  <p>To Account</p>
                  <div className="tFlex_bd">
                    {expenseTypeList.map((i) => (
                      <button
                        key={i.value}
                        className={`_baseSpan ${
                          i?.value == form?.to_account_sub_category
                            ? "active"
                            : "_bspDisable"
                        }`}
                        disabled={fromAccountLoading || toAccountLoading || isLoadding}
                        onClick={() => handleAccountTypeChange('to', 'to_account_sub_category', i.value)}
                      >
                        {i.label}
                      </button>
                    ))}
                  </div>
                  {form?.to_account_sub_category != 11 ? (
                    <div className="mt-4">
                      <CustomSelect
                        label="Select Account"
                        options={filteredToAccountList}
                        placeholder="Select Account"
                        name="to_account_id"
                        onSelect={(data) => handleOnChange("to_account_id", data?.value)}
                        error={formError?.to_account_id}
                        value={
                          form?.to_account_id
                            ? filteredToAccountList?.find(
                                (i) => i.value == form?.to_account_id
                              )
                            : { label: "", value: "" }
                        }
                        isLoading={toAccountLoading}
                      />
                    </div>
                  ) : (
                    <div className="mt-4">
                      <CustomSelect
                        label="Select Driver"
                        options={filteredToDriverList}
                        placeholder="Select Driver"
                        name="to_account_id"
                        onSelect={(data) => handleOnChange("to_account_id", data?.value)}
                        error={formError?.to_account_id}
                        value={
                          form?.to_account_id
                            ? filteredToDriverList?.find(
                                (i) => i.value == form?.to_account_id
                              )
                            : { label: "", value: "" }
                        }
                      />
                    </div>
                  )}
                </div>
                
                <div className="_clPay_flex">
                  <div className="singleDiv">
                    <CommonInput
                      type="text"
                      label="Amount (₹)"
                      placeholder="Enter Amount"
                      name="amount"
                      className="__rupeeSymbol"
                      rupeeSymbol={true}
                      errorShow={true}
                      error={formError?.amount}
                      focus={!!formError?.amount}
                      maxLength={10}
                      onChange={({ target: { name, value } }) => handleAmountChange(name, value)}
                      value={form?.amount}
                      disabled={isLoadding}
                    />
                  </div>
                </div>
                
                <div className="_clPay_flex fn_add_more">
                  <span 
                    onClick={() => setAddMore(!showAddMore)}
                    style={{ cursor: 'pointer', color: '#007bff' }}
                  >
                    {showAddMore ? "Less More Details" : "Add More Details"}
                  </span>
                </div>
                
                {showAddMore && (
                  <>
                    <div className="_clPay_flex">
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Description"
                          placeholder="Enter Description"
                          name="description"
                          errorShow={false}
                          error={formError?.description}
                          focus={!!formError?.description}
                          onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                          value={form?.description}
                          disabled={isLoadding}
                        />
                      </div>
                    </div>
                    <div className="_clPay_flex">
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Transaction Number"
                          placeholder="Enter Transaction Number"
                          name="transaction_no"
                          errorShow={false}
                          error={formError?.transaction_no}
                          focus={!!formError?.transaction_no}
                          onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                          value={form?.transaction_no}
                          disabled={isLoadding}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CommonCanvas>
  );
};

export default TransferModal;